import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    deleteActionContainer: {
        justifyContent: "center",
        position: "absolute",
        alignItems: "center",
        bottom: 0,
        right: 0,
        top: 0
    },
    unreadIndicatorDot: {
        height: 8,
        width: 8
    },
    deleteActionButton: {
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%"
    },
    deleteActionText: {
        textAlign: "center"
    },
    contentContainer: {
        flex: 1
    },
    descriptionText: {
        lineHeight: 18
    },
    thumbnailImage: {
        height: 44,
        width: 44
    },
    iconContainer: {
        justifyContent: "center",
        alignItems: "center",
        height: 44,
        width: 44
    },
    cardContainer: {
        alignItems: "flex-start",
        shadowColor: "#000000",
        flexDirection: "row",
        shadowOpacity: 0.08,
        shadowRadius: 4,
        shadowOffset: {
            height: 2,
            width: 0
        },
        width: "100%",
        elevation: 2
    },
    headerRow: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    footerRow: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    titleText: {
        flex: 1
    },
    typeBadge: {
        alignSelf: "flex-start"
    },
    dateText: {
        textAlign: "left"
    },
    wrapper: {
        position: "relative",
        overflow: "hidden"
    }
});
export default stylesheet;
